// extracted by mini-css-extract-plugin
module.exports = {"pageBreak":"pagebreak_pageBreak__UUiVr","pageBreak1":"pagebreak_pageBreak1__bgxk9","pageBreak2":"pagebreak_pageBreak2__3LeQn"};